//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateOrdenes } from "@/typings/store/plugins/easyFirestore/ordenes";

const getters: GetterTree<StateOrdenes, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const ordenes = {
    firestorePath: "dev/v1/ordenes",
    firestoreRefType: "collection",
    moduleName: "ordenes",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default ordenes;
